<div class="colors">
  @for (option of options; track option) {
    <div
      class="color-choice"
      (click)="pick(option)"
    >
      <motn-swatch [color]="option" [size]="30"></motn-swatch>

      @if (color !== option) {
        <div class="check">
          <i class="fa-regular fa-circle"></i>
        </div>
      }

      @if (color === option) {
        <div class="check">
          <i class="fa-solid fa-circle-check"></i>
        </div>
      }
    </div>
  }
</div>
